import { Trans } from 'react-i18next'
import { LocalizedLink } from 'src/components/navigation/localized-link.component'
import { useCurrentProject } from 'src/providers/current-project.provider'

const HumanReviewEmptyState = () => {
  const { project } = useCurrentProject()

  return (
    <div className="c-flex c-flex-col c-flex-grow c-items-center c-justify-center c-w-full c-py-16 c-gap-6">
      <img src="/assets/img/empty-dashboard.svg" alt="" className="c-w-56" />
      <p className="c-text-center c-m-0">
        <Trans
          i18nKey="pages.dashboard.human-review-requests.empty-state"
          components={{
            patientsLink: <LocalizedLink to={`/${project.id}/medical/patients`} className="c-underline" />,
          }}
        />
      </p>
    </div>
  )
}

export default HumanReviewEmptyState
